import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, ICouponDto, IFilterPaginationDto } from '../models';
import { KeyValue } from '@angular/common';

@Injectable()
export class CouponService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getCouponList(
    id: number,
    model: IFilterPaginationDto
  ): Observable<ICouponDto[]> {
    return this.post(`admin/coupon/list/${id}`, model);
  }

  public changeCouponStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/coupon/${id}`, null);
  }

  public changeVisibleStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/coupon/hide/${id}`, null);
  }

  public addCoupon(model: ICouponDto): Observable<IApiResponse<boolean>> {
    return this.post(`admin/coupon/save`, model);
  }

  public deleteCoupon(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/coupon/${id}`);
  }

  public getOfferedMenuItems(
    id: number
  ): Observable<KeyValue<number, string>[]> {
    return this.get(`admin/coupon/offerItem/${id}`);
  }
}
